import { render, staticRenderFns } from "./133.vue?vue&type=template&id=06279dc2&scoped=true&"
var script = {}
import style0 from "./133.vue?vue&type=style&index=0&id=06279dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06279dc2",
  null
  
)

export default component.exports